"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirScrappingExpedition = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var ResourceType_1 = require("../../ResourceType");
var SelectCard_1 = require("../../inputs/SelectCard");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var AphroditeRebalanced_1 = require("../rebalanced/rebalanced_corporation/AphroditeRebalanced");
var AirScrappingExpedition = (function (_super) {
    __extends(AirScrappingExpedition, _super);
    function AirScrappingExpedition() {
        return _super.call(this, {
            name: CardName_1.CardName.AIR_SCRAPPING_EXPEDITION,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.VENUS],
            cost: 13,
            metadata: {
                cardNumber: '215',
                description: 'Raise Venus 1 step. Add 3 Floaters to ANY Venus CARD.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.venus(1).floaters(3).secondaryTag(Tags_1.Tags.VENUS);
                }),
            },
        }) || this;
    }
    ;
    AirScrappingExpedition.prototype.canPlay = function (player) {
        var venusMaxed = player.game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS) && !venusMaxed) {
            var adjustedCost = player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST - AphroditeRebalanced_1.AphroditeRebalanced.rebalancedAphroditeBonus(player, 1);
            return player.canAfford(adjustedCost, { floaters: true });
        }
        return true;
    };
    AirScrappingExpedition.prototype.play = function (player) {
        player.game.increaseVenusScaleLevel(player, 1);
        var floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        floaterCards = floaterCards.filter(function (card) { return card.tags.some(function (cardTag) { return cardTag === Tags_1.Tags.VENUS; }); });
        if (floaterCards.length === 0) {
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 3 floaters', 'Add floaters', floaterCards, function (foundCards) {
            player.addResourceTo(foundCards[0], { qty: 3, log: true });
            return undefined;
        });
    };
    return AirScrappingExpedition;
}(Card_1.Card));
exports.AirScrappingExpedition = AirScrappingExpedition;
//# sourceMappingURL=AirScrappingExpedition.js.map